//@flow
import type { IconAssetType } from "./assets";
import type { IconSizeType } from "./IconSize";
import { iconAssets } from "./assets"; 
import Icon from "./Icon";
import { iconSizes } from "./IconSize";

export { Icon, iconSizes, iconAssets };
export type { IconAssetType, IconSizeType };